// extracted by mini-css-extract-plugin
export default {"logoGouv":"Login_logoGouv__PgbEy","logoLink":"Login_logoLink__S6YYh","logoWrapper":"Login_logoWrapper__NAvKR","feedbackButton":"Login_feedbackButton__CSlRa"};